import styled from 'styled-components'

export const FullPageWrapper = styled.div`
    width:100%;
    height: calc(100vh - 75px);
`;